export enum EAbsencesType {
  VACATION,
  OVERTIME,
  TRAINING,
  SICK_LEAVE,
  HIDDEN,
  RECOVERY_DAY,
}

export enum EAbsenceNotified {
  NOT_NOTIFIED,
  NOTIFIED,
}

export enum EAbsenceStatus {
  OPEN,
  APPROVED,
  REJECTED,
}
